import { render } from "./CalendarApp1.vue?vue&type=template&id=0a000d90&ts=true"
import script from "./CalendarApp1.vue?vue&type=script&lang=ts"
export * from "./CalendarApp1.vue?vue&type=script&lang=ts"

import "./CalendarApp1.vue?vue&type=style&index=0&id=0a000d90&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__